import * as Yup from 'yup';
import { TrashIcon } from "./trash";
import { Container } from './styled';
import { useRouter } from "next/router";
import { LoadingBuffer } from "../utils/Loading";
import React, { useEffect, useState } from "react";
import { Loading } from "@/components/global/Loading";
import { yupResolver } from "@hookform/resolvers/yup";
import { PlansService } from "@/services/endpoints/plans";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TextFieldElaboration } from "../../Inputs/TextField";
import { ActionButtonElaborations } from "../../ActionButton";
import { SelectFieldElaboration } from "../../Inputs/SelectField";
import { usePreparationOfPlans } from "@/hooks/elaboracao_planos";
import { RadioCheckedElaboration } from "../../Inputs/RadioButton";
import { useForm, SubmitHandler, useFieldArray } from "react-hook-form";
import { useSnackbarElaboration } from "@/hooks/useSnackbarElaboration";
import { findingMenuItemKey } from "@/contexts/elaboracao_planos/constants";
import { AsynchronousSelectField } from "../../Inputs/AsynchronousSelectField";
import { useElaborationCardItem } from "@/services/zustand/elaboration_card_item";
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material';

type Inputs = {
  metas: any[];
  objetivos: any[];
  macroacoes: any[];
  is_optional?: string;
  justificativa?: string;
}

const Schema = Yup.object().shape({
  is_optional: Yup.string(),
  metas: Yup.array().required(''),
  objetivos: Yup.array().required(''),
  macroacoes: Yup.array().required(''),
  justificativa: Yup.string(),
});

const defaultValue = {
  metas: [{}],
  objetivos: [{}],
  macroacoes: [{}],
}

export const NextLinkingForm: React.FC = () => {
  const {
    watch,
    setValue: setValueDados,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    resolver: yupResolver(Schema), defaultValues: {
      metas: [...defaultValue.metas],
      macroacoes: [...defaultValue.macroacoes],
      objetivos: [...defaultValue.objetivos]
    }
  });

  const { fields: fieldsGoals, append: appendGoals, remove: removeGoal, update: updateGoal } = useFieldArray({
    control,
    name: "metas"
  });

  const { fields: fieldsMacroactions, append: appendMacroactions, remove: removeMacroactions } = useFieldArray({
    control,
    name: "macroacoes"
  });

  const { fields: fieldsObjectives, append: appendObjectives, remove: removeObjectives } = useFieldArray({
    control,
    name: "objetivos"
  });

  const {
    getPlanosVinculados,
    getPlanoObjetivo,
    getPlanoMetas,
    getPlanoMacroacoes,
    PostVinculoFinal,
    GetVinculoFinal,
    getOnePlan,
    DeleteVinculoFinal,
  } = React.useMemo(() => new PlansService(), [])

  const router = useRouter()
  const pathname = router.pathname
  const routerId = router.query.id
  const metas = watch('metas');
  const objetivos = watch('objetivos');
  const macroacoes = watch('macroacoes');
  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [planosMetas, setPlanosMetas] = useState([]);
  const [preview, setPreview] = useState<boolean>(false);
  const [planosObjetivos, setPlanosObjetivos] = useState([]);
  const isOptional = watch("is_optional") as unknown as string;
  const [planosMacroacoes, setPlanosMacroacoes] = useState([]);
  const [disabeSubmit, setDisableSubmit] = React.useState(false);
  const [planosSelecteds, setPlanosSelecteds] = useState<any>({});
  const justificativa = watch("justificativa") as unknown as string;
  const { toggleErrorSnackbar, toggleSuccessSnackbar } = useSnackbarElaboration();
  const zustandSelectedCardItem = useElaborationCardItem(state => state.cardItem);
  const { itemsMenu, selectedItemsMenu, setDefaultItemMenuId, setNavigable, handleFetchProgressCodePlanId } = usePreparationOfPlans();

  const [selectedPlan, setSelectedPlan] = React.useState(null);

  const onSubmit: SubmitHandler<Inputs> = (data, event: any) => {

    if (disabeSubmit) return;

    setDisableSubmit(true);

    const getValues = (id: string) => {

      const div = document.getElementById(id);
      const inputs = div?.querySelectorAll('input');
      const values: any = [];

      inputs?.forEach((input) => {
        values.push(input.value);
      });

      return values
    }

    const getIds = (values: any[], planos: any[]) => {

      const itemsIds: any[] = []

      values.forEach((el: any) => {
        const metaid = planos.find((item: any) => item.title == el) as { value: number } | undefined

        if (metaid) {
          itemsIds.push(metaid.value)
        }
      });

      return itemsIds
    }

    const metasIds = getIds(getValues('metas-selects'), planosMetas)
    const objetivosIds = getIds(getValues('objetivos-selects'), planosObjetivos)
    const macroacoesIds = getIds(getValues('macroacoes-selects'), planosMacroacoes)

    const params = {
      metas: metasIds,
      objetivos: objetivosIds,
      macroacaos: macroacoesIds,
      justificativa: data.justificativa,
    }

    PostVinculoFinal(router.query.id, params)
      .then(() => {
        toggleSuccessSnackbar('Vinculação', 'Salva com sucesso.')

        if (event.nativeEvent.submitter.name == 'next_step') {
          setNavigable(true);
          router.push('/dashboard/elaboracao_planos/' + router.query.id)

          const plan = itemsMenu[findingMenuItemKey(zustandSelectedCardItem)] as Record<string, any>;
          if (plan && plan[selectedItemsMenu?.layer as string]) {
            const planId = plan[selectedItemsMenu?.layer as string]
              .find((item: any) => item.id == selectedItemsMenu?.id).id + 1;

            setDefaultItemMenuId(planId);
          }
        } else {
          setNavigable(false);
          handleFetchProgressCodePlanId(router.query.id)

          router.push('/dashboard/elaboracao_planos/' + router.query.id)

          const plan = itemsMenu[findingMenuItemKey(zustandSelectedCardItem)] as Record<string, any>;
          if (plan && plan[selectedItemsMenu?.layer as string]) {
            const planId = plan[selectedItemsMenu?.layer as string]
              .find((item: any) => item.id == selectedItemsMenu?.id).id;

            setDefaultItemMenuId(planId);
          }
        }

        setTimeout(() => toggleSuccessSnackbar(), 3000)
        setTimeout(() => setDisableSubmit(false), 3000);
      })
      .catch((err: any) => {
        toggleErrorSnackbar()
        setTimeout(() => setDisableSubmit(false), 3000);
      })
  };

  const selectChange = async (e: any) => {
    const plan_id = e.target.value

    setLoading(true)
    removeGoal()
    removeMacroactions()
    removeObjectives()

    try {
      setPlanosObjetivos([])
      const planoObjetivoData = await getPlanoObjetivo(plan_id);
      const dataObj = planoObjetivoData.data.map((item: any) => ({
        value: item.id,
        title: item.texto
      }));
      setPlanosObjetivos(dataObj);

      planosSelecteds?.objetivos.forEach((item: any, index: number) => {
        const itemInData = dataObj.find((data: any) => data.value === item.objetivo.id);
        if (itemInData) {
          setValueDados(`objetivos.${index}.objetivos`, {
            value: item.objetivo.id,
            title: item.objetivo.texto
          });
        }
      });
    } catch (error) {
      console.error(error);
    }

    try {
      setPlanosMetas([])
      const planoMetasData = await getPlanoMetas(plan_id);
      const dataMt = planoMetasData.data.map((item: any) => ({
        value: item.id,
        title: item.texto
      }));
      setPlanosMetas(dataMt);

      planosSelecteds?.metas.forEach((item: any, index: number) => {
        const itemInData = dataMt.find((data: any) => data.value === item.meta.id);
        if (itemInData) {
          setValueDados(`metas.${index}.metas`, {
            value: item.meta.id,
            title: item.meta.texto
          });
        }
      });
    } catch (error) {
      console.error(error);
    }

    try {
      setPlanosMacroacoes([])
      const planoMacroacoesData = await getPlanoMacroacoes(plan_id);

      const dataMacr = planoMacroacoesData.data.map((item: any) => ({
        value: item.id,
        title: item.texto
      }));
      setPlanosMacroacoes(dataMacr);

      const macroacoes = planosSelecteds?.macroacaos as any[];
      macroacoes.map((item: any, index: number) => {
        const itemInData = dataMacr.find((data: any) => data.value === item.macroacoes.id);
        if (itemInData) {
          setValueDados(`macroacoes.${index}.macroacoes`, {
            value: item.macroacoes.id,
            title: item.macroacoes.texto
          });
        }
      });
    } catch (error) {
      console.error(error);
    }

    setLoading(false)
  }

  const deleteItem = (plano: string, field: any) => {
    const handlePlan = () => {
      return plano == 'macroacoes' ? 'macroacaos' : plano
    }
    const findPlan = planosSelecteds[`${handlePlan()}`]?.find((selected: any) => {
      switch (plano) {
        case 'objetivos':

          if (selected.objetivo && selected.objetivo.id == field[`${plano}`]?.value) {
            return selected
          }
          break;

        case 'metas':
          if (selected.meta && selected.meta.id == field[`${plano}`]?.value) {
            return selected
          }
          break;

        case 'macroacoes':
          if (selected.macroacoes && selected.macroacoes.id == field[`${plano}`]?.value) {
            return selected
          }
          break;

        default:
          return undefined
          break;
      }

      return undefined
    })

    if (findPlan) {

      const params: any = {
        metas: [],
        macroacaos: [],
        objetivos: [],
      }

      params[`${plano}`] = [findPlan.id]

      DeleteVinculoFinal(router.query.id, params)
        .then(() => {
          // handleOpenSnackbar(
          //   "Deletado com sucesso!",
          //   ""
          // );
        })
        .catch((err: any) => {
          console.error(err)
          // handleOpenSnackbar(
          //   "Erro ao deletar!",
          //   ""
          // );
        })
    }
  }

  const [loadingBuffer, setLoadingBuffer] = React.useState(false);

  useEffect(() => {
    setLoadingBuffer(true)
    getPlanosVinculados().then(({ data }: any) => {
      let dataPlanos = data.map((item: any) => {
        if (item.plano) {
          return {
            value: item.plano.id,
            name: item.plano.plano
          }
        }
      });

      dataPlanos = dataPlanos.filter((value: any) => value !== undefined);

      setPlanos(dataPlanos)
    }).finally(() => setLoadingBuffer(false))
  }, [getPlanosVinculados])

  useEffect(() => {
    if (!router.isReady) return
    if (!routerId) return

    setPreview(router.asPath.includes('preview'));
    GetVinculoFinal(routerId)
      .then(({ data }: any) => {
        setPlanosSelecteds(data)
        setValueDados('is_optional', data?.justificativa?.length > 0 ? 'false' : 'true')
        setValueDados('justificativa', data?.justificativa)
      })
  }, [GetVinculoFinal, router.asPath, router.isReady, routerId, setValueDados]);

  const [tituloPlano, setTituloPlano] = React.useState('')
  React.useEffect(() => {
    if (selectedPlan != null) {
      const plano = planos.find((item: any) => item?.value === selectedPlan) as any
      setTituloPlano(plano.name)
    }
  }, [planos, selectedPlan])

  if (loadingBuffer) {
    return <LoadingBuffer />
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Container>
        <Grid container spacing={2}>
          {!preview &&
            <Grid item xs={12} mt={1}>
              <RadioCheckedElaboration
                errors={errors}
                required={false}
                control={control}
                name="is_optional"
                defaultValue={isOptional == 'true' ? 'true' : 'false'}
                data={[{ value: true, label: 'Sim' }, { value: false, label: 'Não' }]}
                label="Deseja vincular algum de seus objetivos, metas ou macroações aos Planos de longo prazo da Prefeitura?"
              />
            </Grid>
          }
          <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>
            <div style={{ height: '1px', border: 'dashed 1px #B4B4B4' }}></div>
          </Grid>
          {isOptional == 'true' && (
            <>
              <Grid item xs={5}>
                <SelectFieldElaboration
                  data={planos}
                  errors={errors}
                  required={false}
                  register={register}
                  formName="Vinculação"
                  dataNotDisabled={true}
                  placeholder="Selecione"
                  name={`planos_vinculados`}
                  commentTittle={tituloPlano}
                  label="Planos para vinculação"
                  onChange={(e: any) => {
                    selectChange(e);
                    setSelectedPlan(e.target.value)
                  }}
                />
              </Grid>
              {
                loading ?
                  <Loading loading={loading} />
                  :
                  <Grid item xs={12}>
                    <AccordionWrapper
                      errors={errors}
                      name="objetivos"
                      title="Objetivos"
                      items={objetivos}
                      preview={preview}
                      register={register}
                      tituloPlano={tituloPlano}
                      deleteItem={deleteItem}
                      planosItems={planosObjetivos}
                      removeItem={removeObjectives}
                      fieldsItems={fieldsObjectives}
                      appendItems={appendObjectives}
                    />

                    <AccordionWrapper
                      name="metas"
                      title="Metas"
                      items={metas}
                      errors={errors}
                      preview={preview}
                      tituloPlano={tituloPlano}
                      register={register}
                      deleteItem={deleteItem}
                      removeItem={removeGoal}
                      fieldsItems={fieldsGoals}
                      planosItems={planosMetas}
                      appendItems={appendGoals}
                    />

                    <AccordionWrapper
                      errors={errors}
                      name="macroacoes"
                      preview={preview}
                      title="Macroações"
                      items={macroacoes}
                      tituloPlano={tituloPlano}
                      register={register}
                      deleteItem={deleteItem}
                      planosItems={planosMacroacoes}
                      removeItem={removeMacroactions}
                      fieldsItems={fieldsMacroactions}
                      appendItems={appendMacroactions}
                    />
                  </Grid>
              }
            </>
          )}
          {isOptional == 'false' && (
            <>
              <Grid item xs={12}>
                <TextFieldElaboration
                  rows={3}
                  errors={errors}
                  required={false}
                  multiline={true}
                  formName="Vinculação"
                  register={register}
                  name="justificativa"
                  label="Justificativa"
                  commentTittle={justificativa}
                  placeholder={`Deseja vincular algum de seus objetivos, metas ou macroações aos Planos de longo prazo da Prefeitura?`}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: 4 }}>
                <div style={{ height: '1px', background: '#B4B4B4' }}></div>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <ActionButtonElaborations isOptional={isOptional == undefined ? 'false' : 'true'}
              layer_indicator={selectedItemsMenu?.demostration_layer} />
          </Grid>
        </Grid>
      </Container>
    </form>
  )
}


const AccordionWrapper = ({
  items,
  errors,
  preview,
  register,
  name = '',
  title = '',
  deleteItem,
  tituloPlano,
  removeItem,
  planosItems,
  appendItems,
  fieldsItems = [],
}: {
  items: any,
  errors: any,
  name: string,
  register: any
  title: string,
  removeItem: any,
  deleteItem: any,
  appendItems: any,
  tituloPlano: string,
  preview: boolean
  fieldsItems: any[],
  planosItems: any[],
  setItemHandler?: any,
}) => {
  const removeItemHandler = (field: any, itemIndex: number) => {
    deleteItem(name, field)
    removeItem(itemIndex);
  }

  useEffect(() => {
    if (fieldsItems.length == 0) {
      appendItems([{}])
    }
  }, [appendItems, fieldsItems.length]);

  const handlePlaceholder = (title: any) => {
    if (title == 'Objetivos') {
      return 'Escolha um objetivo'
    }

    if (title == 'Metas') {
      return 'Escolha uma meta'
    }

    return 'Escolha uma macroação'
  };

  const AccordionCallBack = () => {
    if (planosItems.length == 0) {
      return (
        <p>
          Sem {title}
        </p>
      )
    }

  const handleFormName = (name: string) => {
    if (name == 'macroacoes') {
      return 'macroações';
    } else {
      return name;
    }

  }

    return <>
      {fieldsItems.map((field: any, itemIndex) => (
        <Grid container spacing={2} key={field.id} sx={{ background: '#fff', mt: itemIndex == 0 ? 0 : 2 }}>
          <Grid item xs={12} sx={{ mb: 2, mr: 2 }}>
            <AsynchronousSelectField
              label={tituloPlano}
              errors={errors}
              formName={`Vinculação ${handleFormName(name)}`}
              required={false}
              disabled={preview}
              commentTittle={field[name]?.title}
              data={planosItems}
              defaultValue={field[`${name}`]}
              name={`${name}.${itemIndex}.${name}`}
              placeholder={handlePlaceholder(title)}
              {...register(`${name}.${itemIndex}.${name}`)}
            />
          </Grid>
          <div
            className="remove_line_wrapper"
          >
            {!preview && (
              <span onClick={() => removeItemHandler(field, itemIndex)}>
                <TrashIcon />
                <p>Excluir</p>
              </span>
            )}
          </div>
        </Grid>
      ))}
      <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
        <div className="add_line_wrapper">
          {!preview && (
            <p onClick={() => appendItems([{}])}>
              {`+ Adicionar vinculação`}
            </p>
          )}
        </div>

      </Grid>
    </>
  }

  return (
    <Accordion sx={{ background: '#DFDFDF', mt: 2 }} >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <p className="sub_item_topographic">
          {title}
        </p>
      </AccordionSummary>
      <AccordionDetails sx={{ ml: 2 }} id={`${name}-selects`} >
        {AccordionCallBack()}
      </AccordionDetails>
    </Accordion>
  )
}
